export const RECENTLY_MASTERED_TITLE = 'Recently Mastered';
export const MASTERED_TITLE = 'Mastered';
export const IN_PROGRESS_TITLE = 'In Progress';
export const ARCHIVED_TITLE = 'Archived';

export const MASTERED_STATUS_CRITERIA_MET = 'criteria-met';
export const MASTERED_STATUS_IN_PROGRESS = 'in-progress';
export const MASTERED_STATUS_NOT_STARTED = 'not-started';
